// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production          : false,
  API_SERVER          : 'http://localhost:3000',
  API_URL             : 'http://localhost:3000/api/v13',
  DEFAULT_LANGUAGE    : 'en',
  ENV_NAME            : 'local',
  GOOGLE_ANALYTICS_ID : 'UA-97848842-2',
  GOOGLE_AUTH_URL     : 'auth/google',
  GOOGLE_LOGOUT_URL   : 'https://www.google.com/accounts/logout?continue=https://appengine.google.com/_ah/logout?continue=',
  GOOGLE_MAP_KEY      : 'AIzaSyCS6GvpdzXUC7HOdaNtY1RnU5qIQWfmDgE',
  INDEX_PAGE_TITLE    : 'Sign In | Control FMS',
  LOGIN_PAGE          : '/login',
  encrypt_passcode : '6478'
};
